<template>
  <div :class="[baseCss, 'select-none', 'text-sm']" :data-uuid="uuid" :style="{color, width}">
    <table-layout :class="[`${baseCss}-description`]" y-align="middle" x-align="center" v-if="name || description">
      <row v-if="name">
        <cell v-html="name" :class="['font-semibold', 'text-sm', 'p-1']" />
      </row>
      <row v-if="description">
        <cell v-html="description" :class="['text-xs', 'p-1']" />
      </row>
    </table-layout>
    <table-layout equal-cells y-align="middle" x-align="center" :class="[`${baseCss}-chord`]">
      <row :class="[`${baseCss}-tuning`]">
        <cell v-if="showFretNumber" :class="['px-1', 'py-2']" />
        <cell v-for="(key, index) in tuning" :key="index" v-html="key" :class="['font-semibold', 'px-1', 'py-2']" />
      </row>
      <row :class="[`${baseCss}-chord`]" v-if="frets" v-for="fret in frets" :key="fret">
        <cell v-if="showFretNumber" v-html="romanize(startAt + fret - 1).toLowerCase()" x-align="right" :class="['px-1', 'text-xs', 'py-2', 'font-semibold']" />
        <cell v-for="(key, index) in tuning" :key="index" :class="['px-1', 'py-2', 'relative']">
          <div :class="[`${baseCss}-string`, 'absolute', 'left-1/2', 'top-0', 'pointer-events-none']" :style="{background: color}" />
          <avatar :text="positions[index].finger" :class="[`${baseCss}-dot`, 'relative']" v-if="positions[index].fret === fret" elevation="none" :style="{background: color, color: dotFontColor}" :size="`${dotSize}px`" />
          <avatar v-else :size="`${dotSize}px`" :class="['invisible']" />
        </cell>
      </row>
    </table-layout>
    <reactive-style>
    .bcq-chord-diagram[data-uuid="{{ uuid }}"] .bcq-chord-diagram-chord div[role="cell"]
    {
      border-bottom: solid {{ thickness }}px {{ color }};
    }
    .bcq-chord-diagram[data-uuid="{{ uuid }}"] .bcq-chord-diagram-string
    {
      width: {{ thickness }}px;
    }
    .bcq-chord-diagram[data-uuid="{{ uuid }}"] .bcq-avatar > div
    {
      font-size: {{ dotFontSize }};
      line-height: {{ dotFontSize }};
    }
    </reactive-style>
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'ChordDiagram',
  mixins: [
    methods
  ],
  data () {
    return {
      uuid: this.$uuidv4(),
      baseCss: this.componentBaseCss('chord-diagram', [])
    }
  },
  props: {
    tuning: {
      type: Array,
      default: () => {
        return ['E', 'A', 'D', 'G', 'B', 'E']
      }
    },
    width: {
      type: String,
      default: 'auto'
    },
    showFretNumber: {
      type: Boolean,
      default: true
    },
    positions: {
      type: Array,
      default: () => {
        return []
      }
    },
    startAt: {
      type: Number,
      default: 1
    },
    name: {
      type: String
    },
    description: {
      type: String
    },
    color: {
      type: String,
      default: '#000'
    },
    dotFontColor: {
      type: String,
      default: '#fff'
    },
    dotFontSize: {
      type: String,
      default: '11px'
    },
    thickness: {
      type: Number,
      default: 2
    },
    dotSize: {
      type: Number,
      default: 19
    },
    frets: {
      type: Number,
      default: 4
    }
  }
}
</script>
<style>
.bcq-chord-diagram .bcq-chord-diagram-chord div[role="row"]:last-of-type div[role="cell"],
.bcq-chord-diagram .bcq-chord-diagram-chord div[role="row"]:first-of-type div[role="cell"]
{
  border-bottom: 0;
}

.bcq-chord-diagram .bcq-chord-diagram-string
{
  height: 100%;
  transform: translateX(-50%);
}

.bcq-chord-diagram .bcq-avatar:hover
{
  transform: scale(1.5);
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/chord-diagram/chord-diagram.vue